import { Grid2 as Grid } from "@mui/material";
import { TextField } from "../../common";
import { Button } from "../../common";
import { OrganizationIntegrationsInfo } from "../../../types";
import { editPaymentGatewayIntegrationSchema } from "../../../validations";
import { useValidateForm } from "../../../hooks";
import { useState } from "react";

type EditPaymentGatewayIntegrationInfoProps = {
  data: OrganizationIntegrationsInfo;
  handleEdit: (data: any) => void;
  handleDiscard: () => void;
};

export const EditPaymentGatewayIntegrationInfo = ({
  data,
  handleEdit,
  handleDiscard,
}: EditPaymentGatewayIntegrationInfoProps) => {
  const [hasChanges, setHasChanges] = useState(false);

  const { register, handleSubmit, errors, reset } = useValidateForm(
    editPaymentGatewayIntegrationSchema,
  );

  const handleChange = () => {
    setHasChanges(true);
  };

  return (
    <Grid
      container
      component={"form"}
      onSubmit={handleSubmit(handleEdit)}
      noValidate
      size={{ sm: 12, md: 6 }}
      direction={"column"}
      spacing={4}
      sx={{
        boxShadow: "0px 0px 4px 0px #00000040",
        borderRadius: "10px",
        p: 4,
        position: "relative",
        justifyContent: "space-between",
      }}
    >
      <Grid container size={12}>
        <Grid container size={12}>
          <TextField
            label="Worldpay Acceptor ID"
            name="wpAcceptorId"
            register={register}
            error={errors["wpAcceptorId"]}
            defaultValue={data.worldpay?.wpAcceptorId}
            onChange={handleChange}
          />
        </Grid>
        <Grid container size={12}>
          <TextField
            label="Worldpay Account ID"
            name="wpAccountId"
            register={register}
            error={errors["wpAccountId"]}
            defaultValue={data.worldpay?.wpAccountId}
            onChange={handleChange}
          />
        </Grid>
        <Grid container size={12}>
          <TextField
            label="Worldpay Account Token"
            name="wpAccountToken"
            register={register}
            error={errors["wpAccountToken"]}
            defaultValue={data.worldpay?.wpAccountToken}
            onChange={handleChange}
          />
        </Grid>
        <Grid container size={12}>
          <TextField
            label="Worldpay Terminal ID"
            name="wpTerminalId"
            register={register}
            error={errors["wpTerminalId"]}
            defaultValue={data.worldpay?.wpTerminalId}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Grid
        container
        size={{ xs: 12 }}
        flexDirection={{ xs: "column", md: "row" }}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <Grid size={{ xs: 12, md: 6 }}>
          <Button
            label="Discard"
            variantType="secondary"
            sx={{
              padding: "0.5rem",
              width: "100%",
            }}
            onClick={() => {
              reset();
              handleDiscard();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Button
            type={hasChanges ? "submit" : undefined}
            disabled={!hasChanges}
            label={"Save Changes"}
            sx={{
              padding: "0.5rem",
              width: "100%",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
